import PropTypes from 'prop-types';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DtpContentContainer } from 'dtp-react-components';
import FiltroRelatorioExigenciaAnalitico from './FiltroRelatorioExigenciaAnalitico';
import {
  buscaDestinatarios,
  doPost,
  doGet,
} from '../../utils/requests';
import {
  Button,
} from '../../components/index';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';
import User from '../../domain/User';
import * as listUtils from '../../utils/listsSelect';
import NovoRelatorioExigenciasAnalitico from './NovoRelatorioExigenciasAnalitico';


class TelaRelatorioExigenciaAnalitico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nomeRelatorio: '',
      papelUsuarioLogado: null,
      colunasRelatorio: [],
      listaResultados: [],
      rowAtual: null,
      listaResultadosFormatados: [],
      dataFormatOptions: {},
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
    };
  }

  componentDidMount() {
    sessionStorage.removeItem('filtroRelatorioExigenciaAnalitico');
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    this.definePapelFiltro();
  }

    colunasRelatorio = [
      'Tipo Exigência',
      'Comentário Exigência',
      'CPF',
      'Protocolo',
      'Tipo Requerimento',
      'Nome do beneficiário',
      'Data da abertura',
      'Data da situação',
    ]

    listaColunasFormatar = [
      { index: 2, tipo: 'cpf' },
    ];

    limparTipoRequerimento = (tipoAposentadoria) => {
      let retorno = tipoAposentadoria;
      if (tipoAposentadoria.indexOf('ã') !== -1) {
        retorno = 'pensao';
      }
      return retorno.toLowerCase();
    }

    handleClickDetalhe = (tipoAposentadoria, protocolo) => {
      this.setState({ tipoRequerimentoSelecionado: this.limparTipoRequerimento(tipoAposentadoria) });
      doGet(
        `requerimentos-compensacao-${this.limparTipoRequerimento(tipoAposentadoria)}/${protocolo}`,
        this.handleClickNovoEstadoSuccess,
        this.handleClickNovoEstadoFail,
      );
    }

    handleClickNovoEstadoSuccess = (response) => {
      this.pushNavegacao(this.state.tipoRequerimentoSelecionado, response.data.protocolo);
    }

    pushNavegacao = (tipo, protocolo) => {
      this.props.history.push(`/requerimento/${tipo}/${protocolo}`);
    }

    handleClickNovoEstadoFail = () => {
    }

    montaColuna = tipo => (cell, row) => {
      let valor = cell;
      if (tipo === 'numero') {
        valor = new Intl.NumberFormat('pt-BR').format(cell);
      } else if (tipo === 'cpf') {
        valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
      } else if (tipo === 'cnpj') {
        valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
      } else if (tipo === 'nit') {
        if (Number.isInteger(cell)) {
          valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        } else {
          valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        }
      } else if (tipo === 'botao') {
        valor = (
          <Button
            hint="ir para o requerimento"
            icon="ico-doc-magnifier"
            mini
            onClick={() => this.handleClickDetalhe(row.tipoRequerimento, row.protocolo)}
          />
        );
      }

      return (
        <React.Fragment>
          {valor}
        </React.Fragment>
      );
    }

    relatorioDataFormatOptions = {
      2: this.montaColuna('cpf'),
      8: this.montaColuna('botao'),
    }


    tratarErro = (error) => {
      if (error) {
        const { data } = { ...error };
        if (error.status) {
          if (error.status === 404) {
            this.addMessage('Nenhum resultado encontrado para o filtro informado.');
          } else {
            this.addMessage(`${data.mensagem}`);
          }
        } else {
          this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
        }
      }
    };

    addMessage = (text) => {
      const message = {
        title: 'Titulo',
        text,
        timeout: 5000,
        type: 'danger',
      };
      window.DtpSnackbar.addMessage(message);
    };

    definePapelFiltro = () => {
      let retorno = '';
      const isRgps = this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'consultar-compensacao-rgps']);
      const isRpps = this.props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']);
      const isAnalistaSprev = this.props.auth.checkPermission(['analisar-negocio-sprev']);
      const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);
      const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);
      const isAuditorComprev = this.props.auth.checkPermission(['auditar-comprev']);

      if (isRgps) {
        retorno = 'analista-rgps';
      }
      if (isRpps) {
        retorno = 'analista-rpps';
      }
      if (isAnalistaSprev) {
        retorno = 'analista-sprev';
      }
      if (isAnalistaDtp) {
        retorno = 'analista-dtp';
      }
      if (isAnalistaDcomp) {
        retorno = 'analista-rgps';
      }
      if (isAuditorComprev) {
        retorno = 'auditor-comprev';
      }

      this.setState({
        papelUsuarioLogado: retorno,
      }, () => this.buscarParticipantePeloCnpjLogado());
    }

    buscarParticipantePeloCnpjLogado = () => {
      if (ehPapelObservadorRelatorio(this.state.papelUsuarioLogado) || this.state.papelUsuarioLogado === 'analista-rpps') {
        const usuarioLogado = new User(localStorage.getItem('jwt'));
        const cnpj = usuarioLogado.cnpjDoPapel();
        if (cnpj) {
          doGet(
            `participantes-compensacao/${cnpj}`,
            this.handleSuccessBuscaPeloCnpjLogado,
            this.handleErrorBuscaPeloCnpjLogado,
          );
        }
      } else if (this.state.papelUsuarioLogado === 'analista-rgps') {
        this.setState({
          nomeSolicitante: 'RGPS',
        });
      }
    }

    handleSuccessBuscaPeloCnpjLogado = (response) => {
      let nome = '';
      if (response.data) {
        nome = `${response.data.nome} - ${response.data.codigo}`;
        this.setState({
          nomeSolicitante: nome,
        });
      }
    }

    defineNivelFiltro = () => {
      if (this.state.filtrosEscolhidos.participante) {
        return 4;
      } else if (this.state.filtrosEscolhidos.aps) {
        return 3;
      } else if (this.state.filtrosEscolhidos.gex) {
        return 2;
      } else if (this.state.filtrosEscolhidos.superintendencia) {
        return 1;
      }
      return 0;
    }

    handleErrorBuscaPeloCnpjLogado = () => (
      ''
    );

    definirValorUo = (nivel) => {
      if (nivel === 3) {
        return this.state.filtrosEscolhidos.aps;
      } else if (nivel === 2) {
        return this.state.filtrosEscolhidos.gex;
      } else if (nivel === 1) {
        return this.state.filtrosEscolhidos.superintendencia;
      }
      return 0;
    }

    realizaConsulta = (filtro) => {
      let filtrosEscolhidos = {};
      if (filtro) {
        filtrosEscolhidos = this.montaFiltros(filtro);
      }
      this.setState({
        ...this.state,
        filtrosEscolhidos,
        filtrosAtuais: filtro,
      }, () => this.buscarRelatorio());
    }

    converterValoresParaTipoNumerico = (valor) => {
      let retorno = null;
      if (valor) {
        retorno = Number(valor);
      }
      return retorno;
    }

    extrairValoresParaPesquisar = () => {
      const listaValores = this.state.filtrosEscolhidos.lista;
      const lista = [];
      let valor;
      if (listaValores.length > 0) {
        listaValores.forEach((item) => {
          if (item.value) {
            valor = Number(item.value);
            lista.push(valor);
          }
        });
      }
      return lista;
    }

    buscarRelatorio = () => {
      if (Object.entries(this.state.filtrosEscolhidos).length === 0) {
        return;
      }
      const url = 'relatorios/analiticos/exigencias';
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      const nivel = this.defineNivelFiltro();

      const parametros = {
        tipoParticipacao: this.converterValoresParaTipoNumerico(this.state.filtrosEscolhidos.opcao),
        participante: this.state.filtrosEscolhidos.participante,
        estado: this.converterValoresParaTipoNumerico(this.state.filtrosEscolhidos.estado),
        tipos: this.extrairValoresParaPesquisar(),
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      };

      if (this.state.filtrosEscolhidos.participanteObservador) {
        parametros.participanteObservador = this.state.filtrosEscolhidos.participanteObservador;
      }

      if (this.state.papelUsuarioLogado === 'analista-rgps' || this.state.filtrosEscolhidos.participanteObservador === '01000') {
        parametros.nivelUo = nivel;
        parametros.idUo = this.definirValorUo(nivel);
      }

      this.setState({
        urlExportacao: url,
        parametrosExportacao: parametros,
      }, () => this.preparaRequest(url, parametros));
    }

    preparaRequest = (url, parametros) => {
      doPost(
        url,
        parametros,
        this.tratarSucesso(),
        this.tratarErro,
      );
    }


    pesquisarColunaJson = (json, coluna) => {
      let retorno = json[coluna];
      if (retorno === undefined) {
        retorno = '';
      }
      return retorno;
    }

    tratarSucesso = () => (response) => {
      let quantidadeTotalResultados = 0;
      if (response.headers['content-range']) {
        const { headers } = { ...response };
        // eslint-disable-next-line
            quantidadeTotalResultados = headers['content-range'].split('/')[1];
      }

      const { estadoTabela } = { ...this.state };
      estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
      let colunasFormatarExportacao = [];
      let dataFormatOptions = {};
      if (response.data !== '') {
        const lista = this.extrairColunasJson(response.data);
        dataFormatOptions = this.relatorioDataFormatOptions;
        colunasFormatarExportacao = this.listaColunasFormatar;
        const dadosFormatados = this.prepararColunasExportacao(lista, colunasFormatarExportacao);
        this.setState({
          listaResultados: lista,
          listaResultadosFormatados: dadosFormatados,
          colunasRelatorio: this.montarColunasCabecalho(),
          dataFormatOptions,
          nomeRelatorio: this.montarLegendaNomeRelatorioPorFiltroSelecionado(),
          estadoTabela,
        });
      }
    }

    montarColunasCabecalho = () => {
      const tableHeader = this.colunasRelatorio.slice();
      tableHeader.push('Detalhe');
      return tableHeader;
    }

    extrairColunasJson = (data) => {
      let objetoLinha = {};
      const dados = data.map((item) => {
        objetoLinha = {
          tipoExigencia: this.pesquisarColunaJson(item, 'tipoExigencia'),
          comentarioExigencia: this.pesquisarColunaJson(item, 'comentarioExigencia') ? this.pesquisarColunaJson(item, 'comentarioExigencia') : '-',
          cpf: this.pesquisarColunaJson(item, 'cpf'),
          protocolo: this.pesquisarColunaJson(item, 'protocolo'),
          tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
          nomeBeneficiario: this.pesquisarColunaJson(item, 'nomeBeneficiario'),
          dataAbertura: this.pesquisarColunaJson(item, 'dataAbertura'),
          dataSituacao: this.pesquisarColunaJson(item, 'dataSituacao'),
        };
        return objetoLinha;
      });
      return dados;
    }

    prepararColunasExportacao = (data, colunas) => {
      const dados = data.map((item) => {
        const linha = Object.assign({}, item);
        colunas.forEach((c) => {
          const key = Object.keys(item)[c.index];
          const coluna = item[key];
          const colunaFormatada = this.formatarColuna(coluna, c.tipo);
          linha[key] = colunaFormatada;
        });
        return linha;
      });
      return dados;
    }

    formatarColuna = (cell, tipo) => {
      let valor = cell;

      if (tipo === 'numero') {
        valor = new Intl.NumberFormat('pt-BR').format(cell);
      } else if (tipo === 'cpf') {
        valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
      } else if (tipo === 'cnpj') {
        valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
      } else if (tipo === 'nit') {
        if (Number.isInteger(cell)) {
          valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        } else {
          valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
        }
      } else if (tipo === 'protocolo') {
        valor = `'${cell}`;
      }
      return valor.trim();
    }

    montarLegendaNomeRelatorioPorFiltroSelecionado = () => {
      const textoFiltro = 'Requerimentos no estado em Exigencia';
      const dataAtual = `${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`;
      const listaAtual = this.state.filtrosEscolhidos.lista;
      const exigencias = `com as exigências: [ ${listaAtual.length ? this.extrairValoresParaPesquisar() : 'TODOS'} ]`;

      return `${textoFiltro} - ${dataAtual} ${exigencias}`;
    }


    montaFiltros = (atributosPesquisa) => {
      let atributos = {};
      if (atributosPesquisa.participanteObservador) {
        atributos = { ...atributos, participanteObservador: atributosPesquisa.participanteObservador };
      }
      if (atributosPesquisa.participante) {
        atributos = { ...atributos, participante: atributosPesquisa.participante };
      }
      if (atributosPesquisa.estado) {
        atributos = { ...atributos, estado: atributosPesquisa.estado };
      }
      if (atributosPesquisa.opcao) {
        atributos = { ...atributos, opcao: atributosPesquisa.opcao };
      }
      if (atributosPesquisa.motivo) {
        atributos = { ...atributos, motivo: atributosPesquisa.motivo };
      }
      if (atributosPesquisa.superintendencia) {
        atributos = { ...atributos, superintendencia: atributosPesquisa.superintendencia };
      }
      if (atributosPesquisa.gex) {
        atributos = { ...atributos, gex: atributosPesquisa.gex };
      }
      if (atributosPesquisa.aps) {
        atributos = { ...atributos, aps: atributosPesquisa.aps };
      }
      if (atributosPesquisa.lista) {
        atributos = { ...atributos, lista: atributosPesquisa.lista };
      }

      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      atributos = { ...atributos, 'max-results': resultadosPorPagina };
      atributos = { ...atributos, 'start-position': primeiroItem };

      return atributos;
    }

    alterarPagina = (pagina, page) => {
      const { estadoTabela } = { ...this.state };
      estadoTabela.paginaAtual = pagina;
      if (pagina === 0) {
        estadoTabela.paginaAtual = 1;
      } else {
        estadoTabela.paginaAtual = pagina;
      }

      if (page) {
        estadoTabela.resultadosPorPagina = page;
      }

      this.setState({
        estadoTabela,
        ...this.state,
      }, this.realizaConsulta());
    }

    defineContainerStyle = () => {
      let width = this.state.colunasRelatorio.length * 130;
      if (width < 1140) {
        width = 1140;
      }
      return {
        width: `${width}px`,
      };
    };

    zerarPaginacao = () => {
      this.preparaNovaConsulta();
    }

    preparaNovaConsulta = () => {
      const estadoTabela = {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      };
      this.setState({
        listaRequerimentosFiltrada: null,
        estadoTabela,
      }, this.realizaConsulta());
    }


    render() {
      const options = {
        noDataText: 'Nenhum requerimento a ser exibido',
        hideSizePerPage: false,
        onPageChange: this.alterarPagina,
        page: this.state.estadoTabela.paginaAtual,
        sizePerPage: this.state.estadoTabela.resultadosPorPagina,
        sizePerPageList: listUtils.linhasPorPagina,
        // alwaysShowAllBtns: false,
      };

      const fetchInfo = {
        dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
      };

      return (
        <DtpContentContainer>
          <FiltroRelatorioExigenciaAnalitico
            titulo="Relatório de Exigência Analítico"
            papelUsuarioLogado={this.state.papelUsuarioLogado}
            destinatarios={this.props.destinatarios}
            userData={this.props.auth.userData}
            handleSearchFilter={this.realizaConsulta}
            observardorDeMudanca={this.zerarPaginacao}
          />
          {this.state.nomeRelatorio !== '' ? (
            <NovoRelatorioExigenciasAnalitico
              legend={this.state.nomeRelatorio}
              bordered
              headers={this.state.colunasRelatorio}
              data={this.state.listaResultados}
              options={options}
              pagination
              remote
              dataFormatOptions={this.state.dataFormatOptions}
              landscape
              containerStyle={this.defineContainerStyle()}
              fetchInfo={fetchInfo}
              rowAtual={this.state.rowAtual}
              urlExportacao={this.state.urlExportacao}
              parametrosExportacao={this.state.parametrosExportacao}
            />
                ) : null
                }
        </DtpContentContainer>
      );
    }
}

TelaRelatorioExigenciaAnalitico.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

TelaRelatorioExigenciaAnalitico.defaultProps = {
  destinatarios: [],
};

// eslint-disable-next-line
const mapStateToProps = (state) => ({
  destinatarios: state.base.destinatarios,
});


export default connect(mapStateToProps)(TelaRelatorioExigenciaAnalitico);



// WEBPACK FOOTER //
// ./src/pages/relatorios/TelaRelatorioExigenciaAnalitico.jsx